"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "renderMessageBarBody_unstable", {
    enumerable: true,
    get: function() {
        return renderMessageBarBody_unstable;
    }
});
const _jsxruntime = require("@fluentui/react-jsx-runtime/jsx-runtime");
const _reactutilities = require("@fluentui/react-utilities");
const _reactlink = require("@fluentui/react-link");
const renderMessageBarBody_unstable = (state, contextValues)=>{
    (0, _reactutilities.assertSlots)(state);
    return /*#__PURE__*/ (0, _jsxruntime.jsx)(_reactlink.LinkContextProvider, {
        value: contextValues.link,
        children: /*#__PURE__*/ (0, _jsxruntime.jsx)(state.root, {})
    });
};
